import { render, staticRenderFns } from "./received.vue?vue&type=template&id=869866d4&scoped=true&"
import script from "./received.vue?vue&type=script&lang=js&"
export * from "./received.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869866d4",
  null
  
)

export default component.exports